//---------------------------------------------------
//  Nom du fichier : CreatePublication.js 
//
//  Description: Component qui sert à la logique
//               de créer une publication
//               
//  Auteur: Vega Laliberté et Alek Del Balso
//---------------------------------------------------

import './CreatePublication.css';
import React, { useState, useEffect } from 'react';

import { sections, path_dict, gradeToSortOrder } from './grades';
import ImageCropper from './ImageCropper';
import Background from './background';
import GradeSelector from "./gradeSelector";
import {callAPI} from './callAPI.js'
import { useTranslation } from "react-i18next";

function CreatePublication({set_publication, info, grade_type, render_markers}) {

    const { t } = useTranslation();
    const [title, setTitle] = useState(info.title ? info.title : '');
    const [description, setDescription] = useState(info.description ? info.description : '');
    const [grade, setGrade] = useState(info.grade ? info.grade : (grade_type == 'american' ? 'vb' : '3'));
    const [cropped, setCropped] = useState(false);
    const [imageSrc, setImageSrc] = useState('');
    const [croppedImage, setCroppedImage] = useState(null);
    const [croppedImageURL, setCroppedImageURL] = useState(null);
    const [modif, setModif] = useState(info.description != undefined)

    const [isUploading, setIsUploading] = useState(false)

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsUploading(true)
        let grade_file = ""
        sections.forEach((section, index) => {
            if(section.includes(grade)){
                grade_file = path_dict[index]
            }
        });

        const form = new FormData()
        if(modif){
            form.append('type', 'modifyPost')
            form.append('post_id', info.post_id)
        }
        else{
            form.append('type', 'createPost')
            form.append('title', title)
            form.append('latitude', info.pos.lat)
            form.append('longitude', info.pos.lng)
        }
        
        form.append('body', description)
        form.append('grade', grade)
        form.append('sort_order', gradeToSortOrder[grade])
        form.append('grade_file', grade_file)
        if(croppedImage != null)
            form.append('file', croppedImage )


    
        callAPI("write", form)
        .then((data) => {
            setIsUploading(false)
            render_markers()
            set_publication(null)
        })
        .catch((error) => {
            console.error("API call failed:", error);
            alert("An error occurred while submitting the publication. Please try again. The file might be too large");
        });
    
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if(!file) return
        setImageSrc(URL.createObjectURL(file)); 
        setCropped(false);
    };

    const handleCropComplete = (croppedBlob) => {
        setCroppedImage(croppedBlob);
        setCropped(true);
    };

    useEffect(() => {
        if (croppedImage) {
            const objectURL = URL.createObjectURL(croppedImage);
            setCroppedImageURL(objectURL);
    
            return () => URL.revokeObjectURL(objectURL); 
        }
    }, [croppedImage]);

    const imagePhoto = {
        backgroundImage: croppedImageURL  ? `url(${croppedImageURL}` : 'none'
    };

    const buttonFileTake = {
        width: !croppedImageURL && !info.image ? '20%' : undefined,
        position: !croppedImageURL && !info.image ? 'absolute' : undefined,
        top: !croppedImageURL && !info.image ? '50%' : undefined,
        left: !croppedImageURL && !info.image ? '50%' : undefined,
        transform: !croppedImageURL && !info.image ? 'translate(-50%, -50%)' : undefined,
    };

    return (
        <Background func={() => {set_publication(null)}}>
            <div className='publicationMaker'>
                {isUploading && 
                <div className='uploading_publication'>
                    <div className='uploading_gif'></div>
                </div>}
                {!cropped && imageSrc && <ImageCropper imageSrc={imageSrc} onCropComplete={handleCropComplete}></ImageCropper>}
                <form method='post' onSubmit={handleSubmit} className='formPub'>
                    <div className='imageDeLaPublicationEnCours' style={info.image != null && croppedImage==null ? {backgroundImage:'url(https://rockstoclimb.com/'+ info.image +')'} : imagePhoto}>
                        <label className='publication_info_container' style={buttonFileTake}>
                            <input 
                            required={info.title == null}
                            type='file'
                            className='buttonFile'
                            name="image" 
                            accept="image/*"
                            onClick={() => {setCropped(false); setImageSrc(null)}}
                            onChange={handleFileChange}
                            />
                            <span className="file-upload-button"></span>
                        </label>
                    </div>
                    <div className='information'>
                        <label className='champInformation'>
                            <p className='titleChamp'>{t('create_publication_title')}</p>
                            {info.title != undefined ? <p className='NonModifiableTitle'>{info.title}</p> : 
                                <input
                                    maxLength={255} 
                                    required 
                                    name="title"
                                    className='titleInputCreate' 
                                    value={title}
                                    onChange={e => setTitle(e.target.value)}/>
                            }                            
                        </label>
                        <label className='champInformation' id='champInformationDesc'>
                            <p className='titleChamp'>{t('create_publication_desc')}</p>
                            <textarea 
                                maxLength={255} 
                                required 
                                name="description"
                                className='titleInputCreate' 
                                style={{paddingTop: "2%"}} 
                                value={description}
                                onChange={e => setDescription(e.target.value)}/>
                        </label>
                        <label className='champInformation'>
                            <p className='titleChamp'>{t('create_publication_grade')}</p> 
                            <GradeSelector gradetype={grade_type} setSelected={setGrade} startWith={grade}></GradeSelector>
                        </label>
                        <button className='btSubmit' type="submit">{t('create_publication_post')}</button>
                    </div>
                </form>
                <div className='quit_container_modify'>
                    <span id="quit_reverse" className="material-symbols-outlined close_modify" onClick={() => set_publication(null)}>close</span>
                </div>
            </div>
        </Background>
    );
}

export default CreatePublication;